import { create } from 'zustand';
import type { WebGrpcDecodedData } from '@terra/shared-schemas-tracker';

type ToolHarGrpcDecodeState = {
  byRequestId: Record<string, WebGrpcDecodedData>;
  setDecodedData: ({
    requestId,
    webGrpcDecodedData,
  }: {
    requestId: string;
    webGrpcDecodedData: WebGrpcDecodedData;
  }) => void;
  removeDecodedData: (requestId: string) => void;
};

export const useToolHarGrpcDecodeStore = create<ToolHarGrpcDecodeState>(
  (set) => ({
    byRequestId: {},
    setDecodedData: ({ requestId, webGrpcDecodedData }) =>
      set((state) => ({
        byRequestId: {
          ...state.byRequestId,
          [requestId]: webGrpcDecodedData,
        },
      })),
    removeDecodedData: (requestId) =>
      set((state) => {
        const { [requestId]: _removed, ...byRequestId } = state.byRequestId;

        return { byRequestId };
      }),
  }),
);
